import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import WebApiRoutes from '@config/Routes/WebApiRoutes';
import WebApiGeneralRoutes from '@config/Routes/WebApiGeneralRoutes';

const baseQuery = fetchBaseQuery({
  baseUrl: WebApiRoutes.getBaseUrl(),
});

const JobRequestApi = createApi({
  reducerPath: 'jobRequestApi',
  baseQuery,
  endpoints: (builder) => ({
    getJobRequests: builder.mutation({
      query: ({ accessToken, parameters }) => ({
        url: WebApiGeneralRoutes.apiV1Path(`/job-requests`, parameters),
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
      }),
    }),

    getJobRequestDetails: builder.mutation({
      query: ({ accessToken, id }) => ({
        url: WebApiGeneralRoutes.apiV1Path(`/job-request-details`, { id }),
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
      }),
    }),

    approveJobRequest: builder.mutation({
      query: ({ accessToken, id }) => ({
        url: WebApiGeneralRoutes.apiV1Path(`/approve-job-request`, { id }),
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
      }),
    }),

    reviseAndApproveJobRequest: builder.mutation({
      query: ({ accessToken, id, payload }) => ({
        url: WebApiGeneralRoutes.apiV1Path(`/revise-and-approve-job-request`, { id }),
        method: 'POST',
        headers: { Authorization: `Bearer ${accessToken}` },
        body: payload,
      }),
    }),

    rejectJobRequest: builder.mutation({
      query: ({ accessToken, id }) => ({
        url: WebApiGeneralRoutes.apiV1Path(`/reject-job-request`, { id }),
        method: 'GET',
        headers: { Authorization: `Bearer ${accessToken}` },
      }),
    }),
  }),
});

export const {
  useGetJobRequestsMutation,
  useGetJobRequestDetailsMutation,
  useApproveJobRequestMutation,
  useReviseAndApproveJobRequestMutation,
  useRejectJobRequestMutation,
} = JobRequestApi;

export default JobRequestApi;
